import React, { RefObject } from 'react';
import TagManager from 'react-gtm-module';
import {
  DatalayerPopupContentTypes,
  DataLayerTrackEvents,
} from '@/datalayer/App.datalayer.constants';
import { useMarketoFormDatalayerPosition } from '@/features/MarketoForm/MarketoForm.datalayer';

export const useMarketoFormModalDatalayer = (
  formId?: string,
  containerRef?: RefObject<HTMLDivElement>,
) => {
  const [dataLayerFormAttributes, setDataLayerFormAttributes] = React.useState({
    lastActiveFieldName: '',
    formType: '',
    formName: '',
  });
  const { getDatalayerPosition } = useMarketoFormDatalayerPosition(containerRef);

  const dataLayerExitPopupForm = React.useCallback(() => {
    const position = getDatalayerPosition();

    const dataLayer = {
      event: 'trackEvent-exitPopupForm',
      event_name: 'exit_popup_form',
      ...(!!dataLayerFormAttributes?.formName && { form_name: dataLayerFormAttributes.formName }),
      ...(!!dataLayerFormAttributes?.formType && { form_type: dataLayerFormAttributes.formType }),
      ...(!!position && { position }),
      form_id: formId,
      ...(!!dataLayerFormAttributes?.lastActiveFieldName && {
        form_field: dataLayerFormAttributes.lastActiveFieldName,
      }),
    };
    TagManager.dataLayer({ dataLayer });
    TagManager.dataLayer({
      dataLayer: {
        event: DataLayerTrackEvents.EXIT_POPUP,
        event_name: 'exit_popup',
        content_type: DatalayerPopupContentTypes.FORM,
        ...(!!dataLayerFormAttributes?.formName && { title: dataLayerFormAttributes.formName }),
      },
    });
  }, [
    dataLayerFormAttributes.formName,
    dataLayerFormAttributes.formType,
    dataLayerFormAttributes.lastActiveFieldName,
    formId,
    getDatalayerPosition,
  ]);

  return { dataLayerExitPopupForm, setDataLayerFormAttributes };
};
